import { render, staticRenderFns } from "./number-control-button.vue?vue&type=template&id=3b2287d6&"
import script from "./number-control-button.vue?vue&type=script&lang=js&"
export * from "./number-control-button.vue?vue&type=script&lang=js&"
import style0 from "./number-control-button.vue?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports